import { fetchRfiService as fetchWithToken } from '../utils/fetchRfiService';
import { getApiBaseUrl } from '../config';
import { headers, HttpMethod } from '../constants';
import { AdvancedSettingsResponseDefinition, AdvancedSettingsRequestDefinition } from '../types';
import { CreateSDKConfig } from './types';

const AdvancedSettingsApi = ({ projectId }: CreateSDKConfig) => {
  const url = `${getApiBaseUrl(projectId)}/settings`;
  return {
    getAll(): Promise<AdvancedSettingsResponseDefinition> {
      return fetchWithToken<AdvancedSettingsResponseDefinition>(url);
    },
    update(body: AdvancedSettingsRequestDefinition): Promise<AdvancedSettingsResponseDefinition> {
      return fetchWithToken<AdvancedSettingsResponseDefinition>(url, {
        method: HttpMethod.Patch,
        body: JSON.stringify(body),
        headers,
      });
    },
  };
};

export default AdvancedSettingsApi;
